const windowStore = {
  namespaced: true,
  state: () => ({
    height: null,
    width: null,
    breakpoints: {
      0: 0,
      XS: 575.98,
      SM: 767.98,
      MD: 991.98,
      LG: 1199.98,
    },
  }),
  mutations: {
    height(state, height) {
      state.height = height;
    },
    width(state, width) {
      state.width = width;
    },
  },
  getters: {
    isXS(state) {
      return state.width < state.breakpoints.XS;
    },
    isSM(state) {
      return state.width < state.breakpoints.SM;
    },
    isMD(state) {
      return state.width < state.breakpoints.MD;
    },
    isLG(state) {
      return state.width < state.breakpoints.LG;
    },
  },
};

export default windowStore;
